import * as React                           from "react"
import Card                                 from "../../../card"
import { FooterItem, LinkFooterItem }       from "../../../card/footer-item"
import { LocalAuthority, LocalAuthorityChapterAccount } from "../../../../model"

class InstructionCardComponent extends React.Component<InstructionCardComponentProps> {
	render() {
		return (
			<Card footerItems={this.getFooterItems(this.props)} loading={this.props.loading} paddingless title="Instruction">
				<table className="is-fullwidth">
					{this.getTableBody(this.props)}
				</table>
			</Card>
		)
	}

	private getFooterItems(props: InstructionCardComponentProps): FooterItem[] {
		return [
			{
				content : "Voir plus",
				disabled: this.props.loading,
				title   : "Voir plus sur l'instruction",
				to      : props.localAuthority ? `/${props.localAuthority.slug}/instruction` : null,
			} as LinkFooterItem,
		]
	}

	private getTableBody(props: InstructionCardComponentProps): JSX.Element {
		if (props.loading) return <tbody><tr><td>Chargement...</td></tr></tbody>

		return props.accounts && props.accounts.length
			? <tbody>
						<tr><td>Nombre de comptes généraux: {this.props.accounts.length}</td></tr>
						<tr><td>Nombre de comptes personnalisés: {this.props.lacaNumber}</td></tr>
						<tr><td>Nombre de chapitres: {this.props.chaptersNumber}</td></tr>
				</tbody>
			: <tbody><tr><td>Aucun compte enregistré</td></tr></tbody>
	}
}

export default InstructionCardComponent

export interface InstructionCardComponentProps {
	accounts: LocalAuthorityChapterAccount[]
	chaptersNumber: Number
	loading: boolean
	localAuthority: LocalAuthority
	lacaNumber: Number
}


// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/instruction-card/instruction-card-component.tsx